import TablaConciliacion from "../../../TablaConciliacion";

function TablaRutaDelValle() {
  return <TablaConciliacion nombreUseCase="RUTADELVALLE" titulo="RUTA DEL VALLE" />;
}

export default TablaRutaDelValle;
